// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1iRhD","options":"AnswerScale_options__138SP","selected":"AnswerScale_selected__QtOi4"};